import type { CommandHandler } from '../types';

export const missingEmployeeRatesCommandHandler: CommandHandler = (command, context) => {
  if (!context.openMissingEmployeeRatesDialog) {
    return {
      success: false,
      error: 'Missing Employee Rates dialog is not available.',
    };
  }

  context.openMissingEmployeeRatesDialog(command);
  return { success: true };
};
